<template>
  <div>
    <div class="menu" v-show="show === 'menu'">
      <div class="toolbar">
        <img class="toolbar-icon click" src="./cj/logo.svg" @click="$emit('logo')" alt="Logo" title="Logo" />
        <img class="toolbar-icon click" src="./cj/twitter.svg" @click="$emit('twitter')" alt="Twitter" title="Twitter" />
        <img class="toolbar-icon click" src="./cj/help.svg" @click="$emit('game-rule')" alt="GameRule" title="GameRule" />
        <img class="toolbar-icon click" src="./cj/logout.svg" @click="$emit('logout')" alt="Logout" title="Logout" />
      </div>

      <!-- <h1 class="title-oo">
        Cell Game
      </h1> -->

      <div class="two-items">
        <div class="left-oo">
          <img src="./img/as-student.svg" title="as a student" @click="onChooseStudent()" alt="as a student">
        </div>
        <div class="right-oo">
          <img src="./img/as-teacher.svg" title="as a teacher" @click="onChooseTeacher()" alt="as a teacher">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as Auth from '../game/auth.js'

export default {
  data () {
    return {
      show: 'menu'
    }
  },
  created () {
    this.$on('logo', () => {
      window.open('https://sites.google.com/view/cell-game')
    })
    this.$on('twitter', () => {
      window.open('https://twitter.com/the_cell_game')
    })
    this.$on('game-rule', () => {
      window.open('https://sites.google.com/view/cell-game/rules')
    })
    this.$on('chat', () => {
      window.open('https://yoteachapp.com/lab/Cell_game_feedback')
    })
    this.$on('logout', () => {
      Auth.logout()
      window.location.assign('/')
    })
  },
  methods: {
    onChooseStudent () {
      this.$emit('choose', 'student')
    },
    onChooseTeacher () {
      this.$emit('choose', 'teacher')
    }
  }
}
</script>

<style scoped>
.title-oo{
  color: white;
  text-align: center;
  font-size: 50px;
}
.two-items{
  margin-top: 20px;

  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

@media screen and (min-width: 767px) {
  .two-items{
    margin-top: 120px;
    flex-direction: row;
  }
}

.right-oo,
.left-oo{
  display: flex;
  justify-content: center;
  width: 37%;
  margin: 20px 20px;
  height: 100px;
}

@media screen and (min-width: 767px) {
   .right-oo,
   .left-oo{
     height: 150px;
  }
}
.two-items img{
  cursor: pointer;
  max-width: 100%;
}

.toolbar{
  width: calc(100% - 15px * 2);
  padding: 15px;
  text-align: right;
}

.toolbar-icon{
  margin-left: 10px;
  height: 30px;
}

@media screen and (min-width: 767px) {
   .toolbar-icon{
     height: 40px;
  }
}
</style>
